import React, { useState, useRef } from 'react';
import { useForm } from '../forms/useForm';
import { useEffect } from 'react';
import { sendRequest } from '../requests/useRequest';
import { validarSesion } from '../tokens/useToken';
import { Code500 } from '../../constant/globalMessage';
import { useHistory } from 'react-router-dom';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import 'moment/locale/es';
import moment from 'moment';
import { getAuthentication } from '../../services/authentications/authentication';
import { Chart } from 'primereact/chart';
import { getGlobalDiscount, getGlobalBonus, getGlobalCancell, getGlobalDevolution } from '../../services/cashFlow/cashFlow'
import { getGlobalCredit } from '../../services/banking/banking'
import { cedimi, phersu } from '../../constant/globalConstantsTypeClients';
import * as XLSX from 'xlsx';
import ConfigDB from '../../data/customizer/config';
const primary = localStorage.getItem('default_color') || ConfigDB.data.color.primary_color;






export const useBankingDeposits = () => {

  const history = useHistory();
  const [createSweet] = useSweetAlert();

  // ? ACTIVE MICROSANITARY
  let _active_micro = localStorage.getItem('active_microsanitary');


  // ? REPORT BANKING
  const [listMovements, setListMovements] = useState(null);
  const [indicatorPatient, setIndicatorPatient] = useState(null);
  const [indicatorAmountInvoice, setIndicatorAmountInvoice] = useState(null);
  const [listMovementsInvoice, setListMovementsInvoice] = useState(null);
  const [disabledSaveButton, setDisabledSaveButton] = useState(false);
  const [validNotification, setValidNotification] = useState(false)

  // ? CALENDER
  const [date, setDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);

  // ? INVOICE
  const [indicadorFullyPaid, setIndicadorFullyPaid] = useState(null);
  const [listFilter, setListFilter] = useState(null);

  const [brach, setBrach] = useState([]);
  const [loadingFinance, setLoadingFinance] = useState([])

  // ? REPORT DISCOUNT
  const [reportDiscounts, setReportDiscounts] = useState([]);
  const [chartData, setChartData] = useState({});
  const [chartOptions1, setChartOptions] = useState({});
  const [countDiscount, setCountDiscount] = useState('0.00');
  const [loadingDiscount, setLoadingDiscount] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const chartRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // ? REPORT BONUS
  const [countBonus, setCountBonus] = useState('0.00');
  const [visibleBonus, setVisibleBonus] = useState(false);
  const [globalBonusFilter, setGlobalBonusFilter] = useState(null)
  const [reportBonus, setReportBonus] = useState([])
  const [chartDataBonus, setChartDataBonus] = useState({});
  const [chartOptionsBonus, setChartOptionsBonus] = useState({});
  const chartBonustRef = useRef(null);

  // ? REPORT CANCELL 
  const [visibleCancell, setVisibleCancell] = useState(false);
  const [globalCancellFilter, setGlobalCancellFilter] = useState(null)
  const [chartDataCancell, setChartDataCancell] = useState({});
  const [chartOptionsCancell, setChartOptionsCancell] = useState({});
  const [countPatient, setCountPatient] = useState(0)
  const [cancellPatient, setCancellPatient] = useState([]);
  const chartCancellRef = useRef(null);

  // ? REPORT DEVOLUTION
  const [visibleDevolution, setVisibleDevolution] = useState(false);
  const [countDevolution, setCountDevolution] = useState("0.00")
  const [devolutionPatient, setDevolutionPatient] = useState([])
  const [chartDataDevolution, setChartDataDevolution] = useState({});
  const [chartOptionsDevolution, setChartOptionsDevolution] = useState({});
  const [globalDevolutionFilter, setGlobalDevolutionFilter] = useState(null)
  const chartDevolutionRef = useRef(null);

  // ? CHART INVOICE AND INGRESS
  const [listDetailBranchInvoice, setListDetailBranchInvoice] = useState([]);
  const [invoiceBranch, setInvoiceBranch] = useState([])
  const [monthIn, setMonthIn] = useState(0)
  const [branchId, setBranchId] = useState(0)
  const [ageId, setAgeId] = useState(0)
  const [listInvoices, setListInvoices] = useState([])
  const [detailBranch, setDetailBranch] = useState([])

  const [monthInvoices, setMonthInvoices] = useState([
    { value: 1, label: "Enero" },
    { value: 2, label: "Febrero" },
    { value: 3, label: "Marzo" },
    { value: 4, label: "Abril" },
    { value: 5, label: "Mayo" },
    { value: 6, label: "Junio" },
    { value: 7, label: "Julio" },
    { value: 8, label: "Agosto" },
    { value: 9, label: "Septiembre" },
    { value: 10, label: "Octubre" },
    { value: 11, label: "Noviembre" },
    { value: 12, label: "Diciembre" },
  ]);



  // ? DEPOSIT SEND
  const [totalDepositSend, setTotalDepositSend] = useState(0);
  const [listDetailBranch, setListDetailBranch] = useState([]);
  const [amountDesposit, setAmountDesposit] = useState(0);
  const [arrayDeposits, setArrayDeposits] = useState([]);
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [loadingDeposits, setLoadingDeposits] = useState(false)

  // ? DETAIL PAYMENT COMPLEMENT
  const [dataComplement, setDataComplement] = useState([]);
  const [totalComplement, setTotalComplement] = useState(0);
  const [isComplement, setIsComplement] = useState(false);

  // ? PATIENT COURTESY
  const [dataCortesy, setDataCortesy] = useState([]);

  // ? INVOICE
  const [checkedItems, setCheckedItems] = useState({});
  const [selectAll, setSelectAll] = useState(false);

  // ? INVOICE
  const [modalAutorization, setModalAutorization] = useState(false);
  const [loadingServices, setLoadingServices] = useState(false)

  // ? CONFIGURATION CREDIT COMPANY
  const [valid_view, setValid_view] = useState(false)

  // ? COMPANY CREDIT
  const [companyInfo, setCompanyInfo] = useState([]);

  // ? CONFIGURATION BONUSES 
  const [viewD, setViewD] = useState(false);
  const [viewC, setViewC] = useState(false);

  // ? REPORT BANKING
  const [visibleBanking, setVisibleBanking] = useState(false);

  // ? REPORT MEMBRESIA
  const [visibleMembresia, setVisibleMembresia] = useState(false);

  // * FILTER DATE
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const currentDay = new Date().getDate();

  const startDate = `${currentYear}-${currentMonth <= 9 ? '0' + currentMonth : currentMonth}-01`;
  const endDate = `${currentYear}-${currentMonth <= 9 ? '0' + currentMonth : currentMonth}-${currentDay <= 9 ? '0' + currentDay : currentDay}`;

  const [formQuery, handleInputChange, reset, handleUpdateValues, handleSelectValues] = useForm({
    start_date: startDate,
    end_date: endDate,
    id_branch: 0,
    detail_invoice: true,
    received: "",
    delivere: "",
    amount: 0,
    observation: "",
    date_1: "",
    date_2: "",
    one: false,
    range: false,
    type_action: "A",
    type_company: null

  });

  const { start_date, end_date, id_branch, received, delivere, amount, observation, date_1, date_2, one, range, type_action, type_company } = formQuery;

  //*VALIDATION SEND RECEIVED
  const [validationsSG, setvalidationsSG] = useState({
    amount: false,
    received: false,
    delivere: false
  });

  //*CONFIGURATION FINANCE
  let _valid_Finance = localStorage.getItem('finance');
  let _finance2 = localStorage.getItem('finance_view');
  let _validationFinance = (_valid_Finance === "True" && _finance2 === "False") ? true : false;
  let _cliente = localStorage.getItem('url_helen');


  //*METHOD REPORT BANKING     
  useEffect(async () => {
    await GetReportDeposits();
    await GetDeposits();
    await getBranches();
  }, []);

  useEffect(async () => {
    // if (_valid_Finance === "False") {
    await GetReportDepositsFinance();
    // }


  }, [_valid_Finance]);

  useEffect(() => {
    getBranchesInvoices()
  }, [])




  //*LIST BRANCH
  const getBranches = async () => {
    let _listTemp = await _handleRequest("GET", "Branch/List", "Sucursal");
    if (_listTemp !== null) {
      let _newBranches = [];
      _listTemp.forEach((_obj) => {
        _newBranches.push({
          id_branch: _obj.id_branch,
          name: _obj.name
        });
      });
      setBrach(_newBranches);
    }
  }

  const handleChangeTypeAction = (typeInvoice) => {
    handleUpdateValues({
      ...formQuery,
      type_action: typeInvoice
    });
  }

  // ? REPORT B
  const GetReportDepositsFinance = async () => {
    let _method = '';
    setLoadingFinance(true);

    _method = `ProgrammingSerie/ListProgrammingAmount2/${start_date}/${end_date}`;

    const request = await _handleRequest("GET", _method, "Reporte Bancario");
    setLoadingFinance(false);

    if (request !== null) {
      setLoadingFinance(false);
      //!VALIDATIONS 
      request.forEach((_find, _key) => {
        setDetailBranch(_find.commercialBranchTreeView)
      });
    }
  }

  const [amountSanitary, setAmountSanitary] = useState(0);

  // ? REPORT BANKING
  const GetReportDeposits = async () => {
    let _method = '';

    if (type_company == null) {
      _method = `Reports/GetReportBanking/${start_date}/${end_date}?detail_invoice=true&detail_paid=true&cancel_invoice=true&pending=true`;
    }
    else if (type_company === 1) {

      _method = `Reports/GetReportBanking/${start_date}/${end_date}?detail_invoice=true&detail_paid=true&cancel_invoice=true&pending=true&isType=1`;
    }
    else if (type_company === 2) {

      _method = `Reports/GetReportBanking/${start_date}/${end_date}?detail_invoice=true&detail_paid=true&cancel_invoice=true&pending=true&isType=2`;
    }

    if (id_branch !== 0 && id_branch.value !== undefined) {
      _method = _method + `&id_branch=${id_branch.value}`;
    }

    setLoadingDeposits(true)

    const request = await _handleRequest("GET", _method, "Reporte Bancario");
    setLoadingDeposits(false)


    if (request !== null) {

      GetReportCancell(start_date, end_date)
      getDiscountGlobal(start_date, end_date)
      getBonus(start_date, end_date)
      getDevolution(start_date, end_date)


      let _amounts = 0
      let _sump = 0
      let _totalPayment = 0;
      let _totalDeposits = 0;






      // * REPORT AMOUN
      let _array = [];
      let totalMicAmount = 0;
      request.reportListMovement.forEach(_find => {
        let _var = Math.round(_find.amount);
        let _var2 = Math.round(_find.micAmount ?? 0);

        totalMicAmount += _var2;


        switch (_find.id_pay_method) {
          case 2:
          case 4:
          case 8:
            _totalDeposits += _var;
            break;
        }
        _array.push({
          amount: _var + _var2,
          id_pay_method: _find.id_pay_method,
          pay_method: _find.pay_method
        });

        let formatted = totalMicAmount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        setAmountSanitary(formatted)
      });


      //*GROUP BRANCH CASH FLOW
      let groupedByBranch = {};

      let groupedByBranchInvoice = {};

      request.reportListBranchInvoice.forEach(_find => {
        if (!groupedByBranchInvoice[_find.id_branch]) {
          groupedByBranchInvoice[_find.id_branch] = [];
        }
        groupedByBranchInvoice[_find.id_branch].push(_find);
      });

      request.reportListBranch.forEach(_find => {

        if (_find.id_pay_method === 30 || _find.id_pay_method === 31) {
          return;
        }//!IGNORE
        if (!groupedByBranch[_find.id_branch]) {
          groupedByBranch[_find.id_branch] = [];
        }
        groupedByBranch[_find.id_branch].push(_find);
      });

      request.reportDeposits.forEach((_find) => {
        _amounts += _find.amount
      })


      // ? PAYMENTS
      request.reportPaymentsComplement
        .filter(x => x.uuid !== null)
        .forEach(_find => {
          _totalPayment += _find.payment_amount;
        });

      //!SUM TOTAL DEPOSITS
      _sump = _amounts += _totalDeposits += _totalPayment

      setAmountDesposit(_amounts)
      setListMovements(_array);
      setIndicatorPatient(request.total_patient);
      setIndicatorAmountInvoice(request.total_amountInvoice)
      setListMovementsInvoice(request.reportListInvoice)
      setIndicadorFullyPaid(request.total_fully)
      setTotalDepositSend(_sump)
      setListDetailBranch(groupedByBranch)
      setArrayDeposits(request.reportDeposits)
      setDataComplement(request.reportPaymentsComplement.filter(x => x.uuid !== null) ?? [])
      setTotalComplement(_totalPayment)
      GetFilterInvoices()
      setDataCortesy(request.reportPaymentsCourtesy)
      setListDetailBranchInvoice(groupedByBranchInvoice)
    }
  }



  // * CLEAN REPORT 
  const handleClearValues = () => {
    handleUpdateValues({
      received: "",
      delivere: "",
      amount: 0,
      observation: "",
      date_1: "",
      date_2: ""

    })
  }

  // ? SAVE CALCULATE RECEIVED
  const saveReceived = async () => {
    if (validationReceived()) {
      return;
    }

    setDisabledSaveButton(true);

    let _validFech = formQuery.date_2 === "" ? formQuery.date_1 : formQuery.date_1;
    let _validFech2 = formQuery.date_2 != "" ? formQuery.date_2 : formQuery.date_1;

    createSweet("info", "info", "Recopilando información, para validar!");

    let _body = {
      user_received: formQuery.received,
      user_delivere: formQuery.delivere,
      amount: formQuery.amount,
      observation: formQuery.observation,
      date_1: _validFech2,
      date_2: _validFech
    }

    const listTmp = await _handleRequest("POST", `CashFlow/CreateDeposits`, "Facturación", _body);

    if (listTmp !== null) {
      createSweet("create", "info", "Exito!", "Se genero el deposito con exito!");
      setDisabledSaveButton(false);
    }
    else {
      setDisabledSaveButton(false);

    }
    handleClearValues();
  }

  const onChange = (newDate) => {
    setDate(newDate);
    setSelectedDate(newDate);

  };


  // ? DEPOSIT 
  const GetDeposits = async () => {
    let _valid = moment(date).format("YYYY-MM-DD");

    let _method2 = `Reports/GetReportDeposits/${_valid}`;

    const request = await _handleRequest("GET", _method2, "Deposito bancario");

    if (request == null) {
      setValidNotification(false);
    }
    else {
      setValidNotification(true);
    }
  };

  useEffect(() => {

    if (validNotification == true && validNotification == false) {
      setSelectedDate(date);
    }

  }, [validNotification, date]);


  const tileClassName = ({ date }) => {
    const isSelected = selectedDate && moment(date).isSame(selectedDate, 'day');
    return isSelected ? (validNotification ? 'selected-valid' : 'selected-invalid') : '';
  };

  // ? FILTER INVOICES
  const GetFilterInvoices = async (_valid) => {

    let _valid2 = _valid === undefined ? `Reports/GetReportFilterInvoices/${start_date}/${end_date}` : _valid === 1 ? `Reports/GetReportFilterInvoices/${start_date}/${end_date}?id_branch=1` : `Reports/GetReportFilterInvoices/${start_date}/${end_date}?id_branch=2`
    let _method = _valid2

    if (id_branch !== 0 && id_branch.value !== undefined) {
      _method = _method + `&id_branch=${id_branch.value}`;
    }

    const request = await _handleRequest("GET", _method, "Filtro");

    if (request !== null) {
      setListFilter(request.reportFiltersInvoice)
    }
  }



  // ? TYPE METHOD
  const handleActions = async () => {
    if (_valid_Finance === "True") {
      if (_finance2 === "True") {
        await GetReportDepositsFinance();
        await GetReportDeposits();
      }
      else {
        await GetReportDeposits();
      }
    }
    else {
      await GetReportDeposits();
    }
  }



  // ? CONFIGURATION COMPLEMENT PAYMENT
  const handleViewDetalil = () => {
    setIsComplement(true)
  }

  const handleClosedViewDetalil = () => {
    setIsComplement(false)
  }

  // ? CONGIGURATION BRANCH
  const getBranchesInvoices = async () => {
    let _listTemp = await _handleRequest("GET", "Branch/List", "Sucursal");
    if (_listTemp !== null && _listTemp.length > 0) {
      let _allOption = {
        value: 0,
        label: "TODAS LAS SUCURSALES"
      };

      let _newBranches = [_allOption];

      _listTemp.forEach((_obj) => {
        _newBranches.push({
          value: _obj.id_branch,
          label: _obj.name
        });
      });
      setInvoiceBranch(_newBranches);
    }
  };

  const handleSelectBranch = (_value) => {
    setBranchId(_value);
  };

  const handleSelectMonth = (_value) => {
    setMonthIn(_value);
  };

  const handleSelectAge = (_value) => {
    setAgeId(_value);
  };

  const handleSelecUser = (_value) => {
    setUsername(_value);
  };

  const handleSelectPassword = (_value) => {
    setPassword(_value);
  };

  const validRangeFech = () => {
    let statusValidation = false;

    if (monthIn === 0 || ageId === 0) {

      statusValidation = true;
    }
    else statusValidation = false;

    return statusValidation;
  }


  const [loadingInvoice, setLoadingInvoice] = useState(false)

  const getInformationInvoices = async () => {

    if (validRangeFech()) {
      createSweet("warning", "warning", "Busqueda", "Se deben llenar los tres campos de busqueda");
      return;
    }
    setLoadingInvoice(true)


    let _method = '';

    if (branchId === 0 || branchId === "0") {
      _method = `Reports/GetReportInvoicesPending/${monthIn}/${ageId}?patient=false`;
    }
    else _method = `Reports/GetReportInvoicesPending/${monthIn}/${ageId}?id_branch=${branchId}&patient=false`;

    const request = await _handleRequest("GET", _method, "Reporte Bancario");

    if (request !== null) {
      setListInvoices(request)
      setLoadingInvoice(false)


    }
    else {
      setListInvoices([])
      setLoadingInvoice(false)

    }
  }
  const [dataInvoicePending, setDataInvoicePending] = useState([])


  useEffect(() => {
    const today = new Date();

    const currentMonth = today.getMonth() + 1; // getMonth() va de 0 a 11
    const currentYear = today.getFullYear();

    setMonthIn(currentMonth);
    setAgeId(currentYear);

    getInformationInvoices2(currentMonth, currentYear);
  }, []);

  const [activeView, setActiveView] = useState(2);
  const [loadingPending, setLoadingPending] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0);


  const requestChangeType = (view) => {

    setActiveView(view)
    setMonthIn(0)
    setBranchId(0)
    setAgeId(0)

    if (view === 1) {
      // setDataInvoicePending([])

    }



    if (view === 2) {
      setActiveIndex(0)
      setMonthIn(0)
      setBranchId(0)
      setAgeId(0)

    }
  };

  const getInformationInvoices2 = async (month = monthIn, year = ageId) => {

    setLoadingPending(true)

    let _method = "";

    if (branchId === 0 || branchId === "0") {
      _method = `Reports/GetReportInvoicesPending/${month}/${year}?patient=true`;
    } else {
      _method = `Reports/GetReportInvoicesPending/${month}/${year}?id_branch=${branchId}&patient=true`;
    }

    const request = await _handleRequest("GET", _method, "Reporte Bancario");
    console.log("🚀 ~ getInformationInvoices2 ~ request:", request)

    console.log(request);

    if (request !== null) {


      setDataInvoicePending(request);
      setLoadingPending(false)

    }
    else {
      setDataInvoicePending([]);
      setLoadingPending(false)

    }
  };




  // ? CHECK INVOICE
  const handleCheckboxChange = (idWorkOrder) => {
    setCheckedItems((prev) => ({
      ...prev,
      [idWorkOrder]: !prev[idWorkOrder],
    }));
  };

  const handleSelectAllChange = () => {
    const newCheckedItems = {};
    listInvoices.forEach((invoice) => {
      const idWorkOrder = invoice.id_work_order;
      newCheckedItems[idWorkOrder] = !selectAll;
    });
    setCheckedItems(newCheckedItems);
    setSelectAll(!selectAll);
  };

  const toggleModalAutorization = () => {
    setModalAutorization(!modalAutorization);
  }

  const handleInvoices = () => {
    toggleModalAutorization()
  }

  // * CONFIGURATION AUTHENTICATION SERVICE 
  const validatePassword = async () => {
    const getList = await getAuthentication(username, password);
    setLoadingServices(true)

    if (getList.result) {
      setLoadingServices(false)

      setUsername("")
      setPassword("")
      saveInvoices()
    }
    else {
      if (_cliente === phersu) {
        setLoadingServices(false)

        setUsername("")
        setPassword("")
        saveInvoices()

      } else {
        setLoadingServices(false)
        createSweet("error", "warning", "Credenciales", "EL usuario o la contraseña no son correctas");
        setUsername("")
        setPassword("")

      }




    }
  }

  const saveInvoices = async () => {
    setLoadingServices(true)

    let _body = Object.keys(checkedItems)
      .filter(key => checkedItems[key])
      .map(key => ({
        "id_work_order": parseInt(key)
      }));

    const listTmp = await _handleRequest("POST", `Reports/UpdateInvoices`, "Reporte", _body);

    if (listTmp) {
      setLoadingServices(false)
      createSweet("create", "info", "Exito!", "Se a actualizado correctamente!");
      toggleModalAutorization()
      getInformationInvoices()
    }
  }

  //*OPEN FINAL REPORT

  const handleReport = (_valid) => {

    if (_valid === undefined || _valid === "" || _valid === null) {

      GetReportCredit(start_date, end_date)
      GetReportCancell(start_date, end_date)
      getDiscountGlobal(start_date, end_date)
      getBonus(start_date, end_date)
      getDevolution(start_date, end_date)
      setValid_view(true)
    }
    else {
      setValid_view(true)
    }
  }

  const handleClosedView = () => {
    setValid_view(false)
  }

  // ? CONFIGURATION CLIENT CREDIT
  const GetReportCredit = async (_startDate, _endDate) => {

    try {
      const detailCredit = await getGlobalCredit(_startDate, _endDate);

      if (detailCredit.code === 200 && Array.isArray(detailCredit.data)) {
        const filteredCompanies = detailCredit.data
          .map(company => {
            const filteredPatients = company.patientDetails?.filter(
              patient => patient.id_pay_method === 10
            );

            if (filteredPatients && filteredPatients.length > 0) {
              return {
                ...company,
                patientDetails: filteredPatients
              };
            }

            return null;
          })
          .filter(company => company !== null);

        if (filteredCompanies.length > 0) {
          setCompanyInfo(filteredCompanies);
        } else {
          setCompanyInfo([]);
          createSweet("warning", "warning", "Opss..", "Sin información de créditos");
        }
      } else {
        setCompanyInfo([]);
        createSweet("warning", "warning", "Opss..", "Sin información de créditos");
      }
    } catch (error) {
      console.error("Error al obtener créditos:", error);
      setCompanyInfo([]);
      createSweet("error", "Error", "Ocurrió un error", "Inténtalo más tarde");
    } finally {
    }
  };


  // ? NAVIGATE NIM
  const navigateNim = (_workOrderId) => {
    let value = "" + _workOrderId + "";
    history.push(`../admisiones/${value}/editar`);
  }

  const handleViewD = () => {
    setViewD(true)
  }

  const handleClosedD = () => {
    setViewD(false)
  }

  const handleViewC = () => {
    setViewC(true)
  }

  const handleClosedC = () => {
    setViewC(false)
  }

  // ? CONFIGURATION DETAIL INVOICE AND INGRES
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
  };

  const getPaymentMethodName = (id) => {
    switch (id) {
      case 1:
        return "Efectivo";
      case 2:
        return "Tarjeta de Crédito";
      case 4:
        return "Tarjeta de Débito";
      case 10:
        return "Crédito";
      case 8:
        return "Transferencia Electrónica";
      case 28:
        return "Ficha de Depósito";
      case 29:
        return "Cortesía";
      default:
        return "Mercado Pago";
    }
  };

  const headerTemplate = (data) => {
    return <strong>{data.branchName}</strong>;
  };

  const allMethodsPaymentsAndInvoices = (_payments, _invoice) => {
    let _array = {};

    _payments.forEach(_pay => {
      if (!_array[_pay?.pay_method]) {
        _array[_pay?.pay_method] = { payments: [], invoices: [] };
      }
      _array[_pay?.pay_method].payments.push(_pay);
    });

    _invoice.forEach(_invoice => {
      if (!_array[_invoice?.pay_method]) {
        _array[_invoice?.pay_method] = { payments: [], invoices: [] };
      }
      _array[_invoice?.pay_method].invoices.push(_invoice);
    });

    return Object.keys(_array).map(_find => ({
      pay_method: _find,
      payments: _array[_find]?.payments,
      invoices: _array[_find]?.invoices,
    }));
  };

  const formatDataForChart = (_search) => {
    let labels = [];
    let incomes = [];
    let invoiced = [];
    let total = [];

    _search.forEach(_search => {
      labels.push(getPaymentMethodName(_search.payments[0]?.id_pay_method));
      const _pay = _search?.payments.reduce((sum, payment) => sum + payment.amount, 0);
      const _invoice = _search?.invoices.reduce((sum, invoice) => sum + invoice.amount, 0);

      incomes.push(_pay);
      invoiced.push(_invoice);
      total.push(_pay - _invoice);

    });

    return {
      labels: [''],
      datasets: [
        {
          label: 'F',
          data: invoiced,
          backgroundColor: '#dc3545',
        },
        {
          label: 'P',
          data: total,
          backgroundColor: '#0079c7',
          color: '#0079c7'
        },
      ],
    };
  };

  const PaymentChart = ({ mergedData }) => {
    const data = formatDataForChart(mergedData);

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      indexAxis: 'y',
      plugins: {
        legend: {
          position: 'left',
          labels: {
            padding: 10,
            usePointStyle: false,
            font: {
              size: 14,
              weight: 'bold',
              family: 'Arial',
              color: '#0079c7'
            }
          },
        },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: 'Monto ($)',
          },
        },
        y: {
          title: {
            display: true,
            text: 'Ingreso - Facturado',
          },
        },
      },
    };


    return (
      <div style={{ width: '95%', height: '390px' }}>
        <Chart type="bar" data={data} options={options} />
      </div>
    );
  };



  const paymentBodyTemplate = (rowData) => {

    let _pay = rowData.payments.reduce((sum, payment) => sum + payment.amount, 0);
    let _invoice = rowData.invoices.reduce((sum, invoice) => sum + invoice.amount, 0);

    let _new_array = allMethodsPaymentsAndInvoices(rowData.payments, rowData.invoices);

    let _all = _new_array.length > 0 && (_pay > 0 || _invoice > 0);

    return (
      <div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: "10px" }}>
          <thead>
            <tr>
              <th
                style={{
                  width: '18%',
                  padding: '5px',
                  border: '1px solid #ddd',
                  textAlign: 'center'
                }}
              >
                Total de Pacientes
              </th>

              <th
                style={{
                  width: '15%',
                  padding: '5px',
                  border: '1px solid #ddd',
                  textAlign: 'center'
                }}
              >
                Ingreso
              </th>

              <th
                style={{
                  width: '15%',
                  padding: '5px',
                  border: '1px solid #ddd',
                  textAlign: 'center'
                }}
              >
                Facturado
              </th>

              <th
                style={{
                  width: '25%',
                  padding: '5px',
                  border: '1px solid #ddd',
                  textAlign: 'center'
                }}
              >
                Detallado
              </th>
            </tr>
          </thead>
          <tbody style={{ fontSize: "10px" }} >
            {!_all ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center', padding: '10px' }}>
                </td>
              </tr>
            ) : (
              <>
                {_new_array.map((method, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {rowData.countPatient > 0 && (
                          <>
                            <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
                              <h6 style={{ margin: '10px 0', color: '#555' }}>Clínico   <br />  <label style={{ color: "#007bff" }}> {rowData.countPatient} </label> </h6>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <img
                                  src={require("../../assets/images/loginHelenLabs/dashboard/people.svg")}
                                  style={{ width: "40px", height: "40px", marginBottom: '5px' }}
                                  alt="Hombres"
                                />
                                <span style={{ color: 'gray', fontWeight: 'bold' }}>Hombres:&nbsp;</span>
                                <span style={{ color: '#2196f3', fontWeight: 'bold' }}>{rowData.countMPatient}</span>
                              </div>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <img
                                  src={require("../../assets/images/loginHelenLabs/dashboard/peopleWoman.svg")}
                                  style={{ width: "40px", height: "40px", marginBottom: '5px' }}
                                  alt="Mujeres"
                                />
                                <span style={{ color: 'gray', fontWeight: 'bold' }}>Mujeres:&nbsp;</span>
                                <span style={{ color: '#ee185fff', fontWeight: 'bold' }}>{rowData.countFPatient}</span>
                              </div>
                            </div>
                          </>
                        )}
                        {rowData.countStotal > 0 && <hr style={{ width: '70%', margin: '20px 0' }} />}
                        {
                          (_active_micro === "True" && _cliente !== cedimi) && <>
                            {rowData.countStotal > 0 && (
                              <div style={{ width: '100%', textAlign: 'center' }}>

                                <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
                                  <h6 style={{ margin: '10px 0', color: '#555' }}>Microsanitaria <br />  <label style={{ color: "#007bff" }}> {rowData.countStotal} </label>  </h6>

                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <img
                                      src={require("../../assets/images/loginHelenLabs/dashboard/MicPeople.svg")}
                                      style={{ width: "40px", height: "40px", marginBottom: '5px' }}
                                      alt="Pacientes"
                                    />
                                    <span style={{ color: 'gray', fontWeight: 'bold' }}>Particulares:</span>
                                    <span style={{ color: '#4caf50', fontWeight: 'bold' }}>{rowData.countSPatient}</span>
                                  </div>
                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <img
                                      src={require("../../assets/images/loginHelenLabs/dashboard/MicCompany.svg")}
                                      style={{ width: "40px", height: "40px", marginBottom: '5px' }}
                                      alt="Empresas"
                                    />
                                    <span style={{ color: 'gray', fontWeight: 'bold' }}>Empresas:</span>
                                    <span style={{ color: '#ff9800', fontWeight: 'bold' }}>{rowData.countMicCompany}</span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        }
                      </div>
                    </td>
                    <td
                      style={{
                        padding: '5px',
                        border: '1px solid #ddd',
                        verticalAlign: 'top',
                      }}
                    >
                      {method.payments.map((payment, paymentIndex) => (
                        <div key={paymentIndex}>
                          <strong>{getPaymentMethodName(payment.id_pay_method)}</strong>: {formatCurrency(payment.amount)}
                        </div>
                      ))}
                    </td>
                    <td
                      style={{
                        padding: '5px',
                        border: '1px solid #ddd',
                        verticalAlign: 'top',
                      }}
                    >
                      {method.invoices.map((invoice, invoiceIndex) => (
                        <div key={invoiceIndex}>
                          <strong>{getPaymentMethodName(invoice.id_pay_method)}</strong>: {formatCurrency(invoice.amount)}
                        </div>
                      ))}
                    </td>
                    <td style={{ padding: '5px', border: '1px solid #ddd', verticalAlign: 'top' }}>
                      <div style={{ width: '70%', height: '70px', }}>
                        <PaymentChart mergedData={[method]} />
                      </div>
                    </td>

                  </tr>
                ))}

                <tr style={{ color: 'white' }}>
                  <td></td>
                  <td style={{ backgroundColor: 'black', padding: '5px', border: '1px solid #ddd', textAlign: 'center' }}>
                    <strong>{formatCurrency(_pay)}</strong>
                  </td>
                  <td style={{ backgroundColor: 'black', padding: '5px', border: '1px solid #ddd', textAlign: 'center' }}>
                    <strong>{formatCurrency(_invoice)}</strong>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    );
  };


  const formattedData = Object.keys(listDetailBranch).map((branchId) => {
    const branchPayments = listDetailBranch[branchId];
    const branchInvoices = listDetailBranchInvoice[branchId] || [];

    const branchName = brach.find(item => item.id_branch === parseInt(branchId))?.name || `Sucursal ${branchId}`;

    const countPatient = branchPayments[0]?.countPatient || 0;
    const countMPatient = branchPayments[0]?.countMPatient || 0;
    const countFPatient = branchPayments[0]?.countFPatient || 0;
    const countStotal = branchPayments[0]?.coutMicTotal || 0;
    const countSPatient = branchPayments[0]?.contMicPatient || 0;
    const countMicCompany = branchPayments[0]?.countMicCompany || 0;



    return {
      branchId: parseInt(branchId),
      branchName,
      payments: branchPayments,
      invoices: branchInvoices,
      countPatient,
      countMPatient,
      countFPatient,
      countStotal,
      countSPatient,
      countMicCompany
    };
  });


  // ? REPORT DISCOUNT
  const getDiscountGlobal = async (_startDate, _endDate) => {
    setLoadingDiscount(true);

    let detailDiscount = await getGlobalDiscount(_startDate, _endDate);

    if (detailDiscount.code === 200) {
      let discounts = detailDiscount?.data;
      setLoadingDiscount(false);

      let _sum = 0;
      if (discounts && discounts.length > 0) {
        _sum = discounts.reduce((acc, item) => acc + (item.amountDiscount || 0), 0);
      }

      let formatted = _sum.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      setCountDiscount(formatted);


      let grouped = {};
      discounts.forEach(item => {
        let id = item.id_percentage;
        let name = item.name_Preloaded_discount || 'Sin nombre';

        if (!grouped[id]) {
          grouped[id] = {
            name,
            total: 0,
            count: 0
          };
        }

        grouped[id].total += item.amountDiscount || 0;
        grouped[id].count += 1;
      });

      let groupedData = Object.values(grouped);
      let colors = [
        '#42A5F5', '#66BB6A', '#FFA726', '#AB47BC',
        '#EC407A', '#FF7043', '#26C6DA', '#D4E157',
        '#8D6E63', '#26A69A', '#7E57C2', '#FFCA28', '#90CAF9'
      ];

      let backgroundColors = groupedData.map((_, i) => colors[i % colors.length]);

      let chartData = {
        labels: groupedData.map(item => item.name),
        datasets: [
          {
            label: 'Total bonificado ($)',
            data: groupedData.map(item => item.total),
            backgroundColor: backgroundColors
          },
          {
            label: 'Veces aplicadas',
            data: groupedData.map(item => item.count),
            backgroundColor: backgroundColors
          }
        ]
      };

      let chartOptions = {
        responsive: true,
        plugins: {
          legend: {
            position: 'top'
          },
          tooltip: {
            callbacks: {
              label: function (ctx) {
                const label = ctx.dataset.label;
                const value = ctx.raw;
                return `${label}: ${label === 'Total bonificado ($)' ? '$' + value.toFixed(2) : value}`;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Cantidad'
            }
          },
          x: {
            ticks: {
              display: false
            },
            grid: {
              display: false
            },
            title: {
              display: false
            }
          }
        }
      };
      setChartData(chartData);
      setChartOptions(chartOptions);
      setReportDiscounts(detailDiscount.data);
    } else {
      setReportDiscounts([]);
      setChartData({});
      setChartOptions({});
    }
  };

  const downloadChart = () => {
    let chartInstance = chartRef.current?.getChart?.();

    if (chartInstance) {
      const base64Image = chartInstance.toBase64Image();

      const link = document.createElement('a');
      link.href = base64Image;
      link.download = 'grafica_descuentos.png';
      link.click();
    } else {
    }
  };

  const showModal = () => {
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
  };

  function exportToExcelDiscount(nimDataExcel) {
    let _Report = [];
    let _array = reportDiscounts;

    _array.forEach((_find, key) => {

      let reportObject = {
        "Nim": _find?.nim,
        "Sucursal": _find?.name_branches,
        "Paciente": _find?.name,
        "Edad": _find?.age,
        "Descuento aplicado": _find?.name_Preloaded_discount,
        "Porcentaje de descuento": _find?.percentagePreloaded_discount,
        "Total de descuento aplicado": _find?.amountDiscount,
        "Total Cobrado": _find?.amount,
        "Metodo de pago": _find?.nameMethod,
        "Fecha de aplicación": _find?.fech
      };
      _Report.push(reportObject);
    });

    const worksheet = XLSX.utils.json_to_sheet(_Report);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = 'Repote Descuentos.xlsx';

    if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
    } else {
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  // ? REPORT BONUS
  const getBonus = async (_startDate, _endDate) => {
    let detailBonus = await getGlobalBonus(_startDate, _endDate);

    if (detailBonus?.code === 200) {

      let bonuses = detailBonus?.data;

      let _sum = 0;
      if (bonuses && bonuses.length > 0) {
        _sum = bonuses.reduce((acc, item) => acc + (item.amount || 0), 0);
      }

      let formatted = _sum.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      setCountBonus(formatted);
      setReportBonus(bonuses);

      let grouped = {};
      bonuses.forEach(item => {
        const id = item.id_user_responsible;
        const name = item.user_responsible || 'Sin nombre';

        if (!grouped[id]) {
          grouped[id] = {
            name,
            total: 0,
            count: 0
          };
        }

        grouped[id].total += item.amount || 0;
        grouped[id].count += 1;
      });

      let groupedData = Object.values(grouped);


      let colorSet2 = [
        '#42A5F5', '#66BB6A', '#FFA726', '#AB47BC',
        '#EC407A', '#FF7043', '#26C6DA', '#D4E157',
        '#8D6E63', '#26A69A', '#7E57C2', '#FFCA28'
      ];

      let colorSet1 = [
        '#90CAF9', '#A5D6A7', '#FFCC80', '#CE93D8',
        '#F48FB1', '#FFAB91', '#80DEEA', '#DCE775',
        '#BCAAA4', '#80CBC4', '#B39DDB', '#FFE082'
      ];

      let userCount = groupedData.length;

      let chartData = {
        labels: groupedData.map(item => item.name),
        datasets: [
          {
            label: 'Total bonificado ($)',
            data: groupedData.map(item => item.total),
            backgroundColor: colorSet1.slice(0, userCount)
          },
          {
            label: 'Veces aplicadas',
            data: groupedData.map(item => item.count),
            backgroundColor: colorSet2.slice(0, userCount)
          }
        ]
      };

      let chartOptions = {
        responsive: true,
        plugins: {
          legend: {
            position: 'top'
          },
          tooltip: {
            callbacks: {
              label: function (ctx) {
                const label = ctx.dataset.label;
                const value = ctx.raw;
                return `${label}: ${label === 'Total bonificado ($)' ? '$' + value.toFixed(2) : value}`;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Cantidad'
            }
          },
          x: {
            ticks: {
              display: false
            },
            grid: {
              display: false
            },
            title: {
              display: false
            }
          }
        }
      };
      setChartDataBonus(chartData);
      setChartOptionsBonus(chartOptions);

    } else {
      setReportBonus([]);
      setChartDataBonus({});
      setChartOptionsBonus({});
    }
  };

  const showModalBonus = () => {
    setVisibleBonus(true);
  };

  const hideModalBonus = () => {
    setVisibleBonus(false);
  };

  const handleDownload = () => {
    let chartInstance = chartBonustRef.current?.getChart?.();

    if (chartInstance) {
      let base64Image = chartInstance.toBase64Image();
      const link = document.createElement('a');
      link.href = base64Image;
      link.download = 'grafica_Bonificaciones.png';
      link.click();
    } else {
    }
  };

  function exportToExcelBonus(nimDataExcel) {
    let _Report = [];
    let _array = reportBonus;

    _array.forEach((_find, key) => {

      let reportObject = {
        "Nim": _find?.nim ?? "---",
        "Paciente": _find?.namePatient ?? "---",
        "Sucursal": _find?.name_branches ?? "---",
        "Metódo de pago": _find?.nameMethod ?? "---",
        "Monto": _find?.amount ?? "---",
        "Fecha": _find?.fech ?? "---",
        "Responsable": _find?.user_responsible ?? "---",
      };
      _Report.push(reportObject);
    });

    const worksheet = XLSX.utils.json_to_sheet(_Report);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = 'Repote Bonificaciones.xlsx';

    if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
    } else {
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  // ? REPORT CANCELL
  const showModalCancel = () => {
    setVisibleCancell(true);
  };

  const hideModalCancel = () => {
    setVisibleCancell(false);
  };

  const [loadingCancell, setLoadingCancell] = useState(false);

  const GetReportCancell = async (alterDateStart = null, alterDateEnd = null) => {
    try {
      setLoadingCancell(true);

      let detailCancell = await getGlobalCancell(
        alterDateStart,
        alterDateEnd
      );

      if (detailCancell.code === 200) {

        let cancell = detailCancell.data;

        let _sum = 0;
        if (cancell && cancell.length > 0) {
          _sum = cancell.reduce((acc, item) => acc + (item.amount || 0), 0);
        }

        let formatted = _sum.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        setCountPatient(formatted)
        setCancellPatient(cancell);

        let grouped = {};
        cancell.forEach(item => {
          let id = item.id_user_responsible;
          let name = item.user_autorized || 'Sin nombre';

          if (!grouped[id]) {
            grouped[id] = {
              name,
              total: 0,
              count: 0
            };
          }

          grouped[id].total += item.amount || 0;
          grouped[id].count += 1;
        });

        let groupedData = Object.values(grouped);

        let colorSet1 = [
          '#42A5F5', '#66BB6A', '#FFA726', '#AB47BC',
          '#EC407A', '#FF7043', '#26C6DA', '#D4E157',
          '#8D6E63', '#26A69A', '#7E57C2', '#FFCA28'
        ];

        let colorSet2 = [
          '#90CAF9', '#A5D6A7', '#FFCC80', '#CE93D8',
          '#F48FB1', '#FFAB91', '#80DEEA', '#DCE775',
          '#BCAAA4', '#80CBC4', '#B39DDB', '#FFE082'
        ];

        let userCount = groupedData.length;

        let chartData = {
          labels: groupedData.map(item => item.name),
          datasets: [
            {
              label: 'Total cancelado ($)',
              data: groupedData.map(item => item.total),
              backgroundColor: colorSet1.slice(0, userCount)
            },
            {
              label: 'Veces aplicadas',
              data: groupedData.map(item => item.count),
              backgroundColor: colorSet2.slice(0, userCount)
            }
          ]
        };

        let chartOptions = {
          responsive: true,
          plugins: {
            legend: {
              position: 'top'
            },
            tooltip: {
              callbacks: {
                label: function (ctx) {
                  const label = ctx.dataset.label;
                  const value = ctx.raw;
                  return `${label}: ${label === 'Total cancelado ($)' ? '$' + value.toFixed(2) : value}`;
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Cantidad'
              }
            },
            x: {
              ticks: {
                display: false
              },
              grid: {
                display: false
              },
              title: {
                display: false
              }
            }
          }
        };
        setChartDataCancell(chartData);
        setChartOptionsCancell(chartOptions);
      } else {
        setCancellPatient([]);
        setChartDataCancell({});
        setChartOptionsCancell({});
      }

    }
    catch (error) {
      createSweet("error", "error", "Opss..", "Error al obtener el reporte de credito");
    }
    finally {
      setLoadingCancell(false);
    }

  };


  const colorPalette = [
    '#42A5F5', '#66BB6A', '#FFA726', '#AB47BC',
    '#EC407A', '#FF7043', '#26C6DA', '#D4E157',
    '#8D6E63', '#26A69A', '#7E57C2', '#FFCA28'
  ];

  const groupedByReason = cancellPatient.reduce((acc, item) => {
    const reason = item.reazon_cancellation || "Sin motivo";
    if (!acc[reason]) {
      acc[reason] = {
        totalAmount: 0,
        count: 0
      };
    }
    acc[reason].totalAmount += item.amount || 0;
    acc[reason].count += 1;
    return acc;
  }, {});

  const labels = Object.keys(groupedByReason);

  const chartDataReason = {
    labels,
    datasets: [
      {
        label: 'Total cancelado ($)',
        data: labels.map(reason => groupedByReason[reason].totalAmount),
        backgroundColor: labels.map((_, i) => colorPalette[i % colorPalette.length])
      }
    ]
  };

  const chartOptionsReason = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (ctx) => `$${ctx.raw.toFixed(2)}`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Monto ($)' }
      },
      x: {
        title: { display: true, text: 'Motivo de cancelación' }
      }
    }
  };


  const handleCancellDownload = () => {
    let chartInstance = chartCancellRef.current?.getChart?.();

    if (chartInstance) {
      const base64Image = chartInstance.toBase64Image();

      const link = document.createElement('a');
      link.href = base64Image;
      link.download = 'grafica_Cancelaciones.png';
      link.click();
    }
  };

  function exportToExcelCancell(nimDataExcel) {
    let _Report = [];
    let _array = cancellPatient;

    _array.forEach((_find, key) => {
      let reportObject = {
        "Nim": _find?.nim ?? "---",
        "Fecha de ingreso": _find?.date_create ?? "---",
        "Usuario de alta": _find?.user_capture_order ?? "---",
        "Sucursal": _find?.branch ?? "---",
        "Paciente": _find?.name_patient ?? "---",
        "Tipo de ingreso": _find?.type ?? "---",
        "Monto": _find?.amount ?? "---",
        "Motivo de cancelación": _find?.reazon_cancellation ?? "---",
        "Responsable": _find?.user_autorized ?? "---",
        "Fecha de cancelación": _find?.date_cancellation ?? "---"
      };

      if (_cliente === cedimi) {
        reportObject["Flujo"] = _find?.flow ? "B" : "A";
      }

      _Report.push(reportObject);
    });
    const worksheet = XLSX.utils.json_to_sheet(_Report);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = 'Reporte Cancelaciones.xlsx';

    if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
    } else {
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  // ? REPORT DEVOLUTION
  const getDevolution = async (_startDate, _endDate) => {

    let detailDevolution = await getGlobalDevolution(_startDate, _endDate);

    if (detailDevolution?.code === 200) {
      let devolution = detailDevolution?.data;

      let _sum = 0;
      if (devolution && devolution.length > 0) {
        _sum = devolution.reduce((acc, item) => acc + (item.amount || 0), 0);
      }

      let formatted = _sum.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      setCountDevolution(formatted)
      setDevolutionPatient(devolution);

      let grouped = {};
      devolution.forEach(item => {
        const id = item.id_user_responsible;
        const name = item.user_autorized || 'Sin nombre';

        if (!grouped[id]) {
          grouped[id] = {
            name,
            total: 0,
            count: 0
          };
        }

        grouped[id].total += item.amount || 0;
        grouped[id].count += 1;
      });

      let groupedData = Object.values(grouped);
      let colorSet1 = [
        '#42A5F5', '#66BB6A', '#FFA726', '#AB47BC',
        '#EC407A', '#FF7043', '#26C6DA', '#D4E157',
        '#8D6E63', '#26A69A', '#7E57C2', '#FFCA28'
      ];

      let colorSet2 = [
        '#90CAF9', '#A5D6A7', '#FFCC80', '#CE93D8',
        '#F48FB1', '#FFAB91', '#80DEEA', '#DCE775',
        '#BCAAA4', '#80CBC4', '#B39DDB', '#FFE082'
      ];

      let userCount = groupedData.length;

      let chartData = {
        labels: groupedData.map(item => item.name),
        datasets: [
          {
            label: 'Total Devuelto ($)',
            data: groupedData.map(item => item.total),
            backgroundColor: colorSet1.slice(0, userCount)
          },
          {
            label: 'Veces aplicadas',
            data: groupedData.map(item => item.count),
            backgroundColor: colorSet2.slice(0, userCount)
          }
        ]
      };

      let chartOptions = {
        responsive: true,
        plugins: {
          legend: {
            position: 'top'
          },
          tooltip: {
            callbacks: {
              label: function (ctx) {
                const label = ctx.dataset.label;
                const value = ctx.raw;
                return `${label}: ${label === 'Total devuelto ($)' ? '$' + value.toFixed(2) : value}`;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Cantidad'
            }
          },
          x: {
            ticks: {
              display: false
            },
            grid: {
              display: false
            },
            title: {
              display: false
            }
          }
        }
      };
      setChartDataDevolution(chartData);
      setChartOptionsDevolution(chartOptions);


    } else {

    }
  };

  const showModalDevolution = () => {
    setVisibleDevolution(true);
  };

  const hideModalDevolution = () => {
    setVisibleDevolution(false);
  };

  function exportToExcelDevolution(nimDataExcel) {
    let _Report = [];
    let _array = devolutionPatient;

    _array.forEach((_find, key) => {

      let reportObject = {
        "Nim": _find?.nim ?? "---",
        "Fecha de ingreso": _find?.date_create ?? "---",
        "Sucursal": _find?.branch ?? "---",
        "Paciente": _find?.name_patient ?? "---",
        "Tipo de ingreso": _find?.type ?? "---",
        "Monto": _find?.amount ?? "---",
        "Motivo de devolución": _find?.reazon_cancellation ?? "---",
        "Responsable": _find?.user_autorized ?? "---",
        "Fecha de devolución": _find?.date_cancellation ?? "---",
      };
      _Report.push(reportObject);
    });


    const worksheet = XLSX.utils.json_to_sheet(_Report);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = 'Reporte Devoluciones.xlsx';

    if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
    } else {
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  const handleDevolutionDownload = () => {
    let chartInstance = chartDevolutionRef.current?.getChart?.();

    if (chartInstance) {
      const base64Image = chartInstance.toBase64Image();

      const link = document.createElement('a');
      link.href = base64Image;
      link.download = 'grafica_devoluciones.png';
      link.click();
    } else {
    }
  };

  // ? BANKING
  const showModalBanking = () => {
    setVisibleBanking(true);
  };

  const hideModalBanking = () => {
    setVisibleBanking(false);
  };
  // ? MEMBRESIA
  const showModalMembresia = () => {
    setVisibleMembresia(true);
  };

  const hideModalMembresia = () => {
    setVisibleMembresia(false);
  };


  // ? PAY METHOD
  const [modalviewPayment, setModalviewCalenderPayment] = useState(false);

  const togglePayment = () => {
    setModalviewCalenderPayment(!modalviewPayment);
  }


  const handlePayment = () => {
    togglePayment()

  }


  // * FUNCTION FORMAT
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })

  //*VALIDATION SEND RECEIVED
  const validationReceived = () => {
    let statusValidation = false;
    let newValidations = {};

    if (formQuery.amount === 0 || formQuery.amount === "") {
      newValidations = {
        ...newValidations,
        amount: true,
      };

      statusValidation = true;
    }
    else {
      newValidations = {
        ...newValidations,
        amount: false,
      };
    }

    if (formQuery.received === "") {
      newValidations = {
        ...newValidations,
        received: true,
      };

      statusValidation = true;
    }
    else {
      newValidations = {
        ...newValidations,
        received: false,
      };
    }

    if (formQuery.delivere === "") {
      newValidations = {
        ...newValidations,
        delivere: true,
      };

      statusValidation = true;
    }
    else {
      newValidations = {
        ...newValidations,
        delivere: false,
      };
    }
    setvalidationsSG(newValidations);
    return statusValidation;
  }

  // * FORMAT NUMBERS
  const number_format = (cantidad, decimals) => {
    cantidad += '';
    cantidad = parseFloat(cantidad.replace(/[^0-9\.]/g, ''));

    decimals = decimals || 0;

    if (isNaN(cantidad) || cantidad === 0) {
      return parseFloat(0).toFixed(decimals);
    }

    cantidad = '' + cantidad.toFixed(decimals);

    let cantidad_parts = cantidad.split('.'),
      regexp = /(\d+)(\d{3})/;

    while (regexp.test(cantidad_parts[0]))
      cantidad_parts[0] = cantidad_parts[0].replace(regexp, '$1' + ',' + '$2');

    return cantidad_parts.join('.');
  }

  const _handleRequest = async (method, methodUrl, nameMethod, body = null) => {
    let requestOptions = {
      method: method
    };

    if (body !== null) {
      requestOptions = {
        ...requestOptions,
        body: JSON.stringify(body)
      };
    }

    const response = await sendRequest(requestOptions, methodUrl);

    if (response.code === 200) {
      return response.data;
    }
    else if (response.code === 401) {
      validarSesion(history, response.code, _handleRequest);
    }
    else if (response.code === 404) {
      // createSweet("warning", "warning", nameMethod, "No se ha realizado ningún deposito bancario en este dia");
    }
    else if (response.code === 500) {
      createSweet("error", "error", nameMethod, Code500);
    }
    else {
      createSweet("warning", "warning", nameMethod, response?.data?.msg);
    }

    return null;
  }

  return {

    // ? REPORT BANKING
    start_date, end_date, handleInputChange, GetReportDeposits, listMovements, indicatorPatient, indicatorAmountInvoice,
    listMovementsInvoice, saveReceived, disabledSaveButton,

    // ? FORMVALUES DEPOSITS
    received, delivere, amount, observation, date_1, date_2, one, range, number_format, validationsSG, GetDeposits,
    type_company, totalDepositSend, listDetailBranch, brach, amountDesposit, arrayDeposits,
    modalAutorization, toggleModalAutorization, handleInvoices, handleSelecUser, handleSelectPassword, validatePassword, loadingServices, username,

    // ? ONCHANGE CALENDER
    date, onChange, validNotification, selectedDate, tileClassName, handleActions, _validationFinance, detailBranch, loadingFinance,
    _valid_Finance,

    // ? VIEW CREDIT, FULLY PAID
    indicadorFullyPaid, handleChangeTypeAction, type_action, listFilter,


    // ? DETAIL PAYMENT COMPLEMENT
    dataComplement, totalComplement, handleViewDetalil, isComplement, handleClosedViewDetalil,
    invoiceBranch, monthInvoices, handleSelectBranch, handleSelectMonth, handleSelectAge, getInformationInvoices, listInvoices,
    checkedItems, selectAll, handleCheckboxChange, handleSelectAllChange, saveInvoices,

    // ? CORTESY
    dataCortesy, handleReport, companyInfo, formatter, navigateNim, countPatient, cancellPatient,
    valid_view, loadingDeposits, _cliente, viewD, viewC, handleViewD, handleClosedD, handleViewC, handleClosedC,

    // ? REPORT DISCOUNT
    headerTemplate, paymentBodyTemplate, reportDiscounts, chartData, chartOptions1, countDiscount, exportToExcelDiscount,
    setGlobalFilter, globalFilter, downloadChart, chartRef, loadingDiscount, visible, showModal, hideModal,

    // ? REPORT BONUS
    reportBonus, visibleBonus, showModalBonus, hideModalBonus, countBonus, chartDataBonus, chartOptionsBonus,
    chartBonustRef, handleDownload, setGlobalBonusFilter, globalBonusFilter, exportToExcelBonus,

    // ? REPORT CANCELL
    exportToExcelCancell, formattedData, visibleCancell, showModalCancel, hideModalCancel, setGlobalCancellFilter, globalCancellFilter,
    chartDataCancell, chartOptionsCancell, handleCancellDownload, chartCancellRef,

    // ? REPORT DEVOLUTION
    chartDataDevolution, chartOptionsDevolution, countDevolution, devolutionPatient, visibleDevolution, showModalDevolution, hideModalDevolution,
    exportToExcelDevolution, chartDevolutionRef, handleDevolutionDownload, globalDevolutionFilter, setGlobalDevolutionFilter,

    // ? REPORT BANKING AND MEMBRESIA
    showModalBanking, hideModalBanking, visibleBanking, showModalMembresia, hideModalMembresia, visibleMembresia,
    chartDataReason, chartOptionsReason, groupedByReason,
    _active_micro, amountSanitary, handleClosedView,
    modalviewPayment, togglePayment, handlePayment,

    activeView, requestChangeType, dataInvoicePending, loadingPending, setActiveView, activeIndex, setActiveIndex,
    getInformationInvoices2, loadingInvoice







  }

}
